function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "cine",
  transform: "translate(-156.243 -397.813)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_105",
  "data-name": "Grupo 105",
  transform: "translate(156.243 397.813)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_60",
  "data-name": "Trazado 60",
  className: "cls-1",
  d: "M177.566,423.253a13.817,13.817,0,1,0-7.494,2.217h15.1v-2.217Zm-7.494-20.726a3.308,3.308,0,1,1-3.308,3.308A3.3,3.3,0,0,1,170.071,402.527Zm-5.806,12.422a3.308,3.308,0,1,1,3.308-3.308A3.3,3.3,0,0,1,164.265,414.949Zm5.806,5.805a3.308,3.308,0,1,1,3.308-3.308A3.3,3.3,0,0,1,170.071,420.755Zm2.463-9.113a3.308,3.308,0,1,1,3.308,3.308A3.326,3.326,0,0,1,172.535,411.641Z",
  transform: "translate(-156.243 -397.813)"
})));

function SvgCine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.924,
    height: 27.657,
    viewBox: "0 0 28.924 27.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCine);
export default __webpack_public_path__ + "static/media/cine.de85e912.svg";
export { ForwardRef as ReactComponent };